import { createFileRoute } from "@tanstack/react-router";

import { ConsoleDevelopersPage } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/developers")({
  component: ConsoleDevelopersPage,
});
